/* Intelligems script */
function change_variant() {
    const rb_container = document.querySelector('.rebuy-widget.widget-type-product')
    if(rb_container) {
        console.log("found")
    } else {
        console.log("not found")
    }
    const ig_options = document.querySelectorAll('.rebuy-widget.widget-type-product .rebuy-product-options .rebuy-select')
    ig_options.forEach(s=>{
      s.addEventListener('change', (event) => {
        let price = s.parentElement.parentElement.querySelector('.rebuy-product-price')
        price.setAttribute('data-variant-id',event.target.value)
        window.console.log(`You selected ${event.target.value}`);
      });
    })
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('.rebuy-widget.widget-type-product').then(()=>{
    setTimeout(() => {
      change_variant()
    }, 600)
})